export var OktaTokensEnum;
(function (OktaTokensEnum) {
    OktaTokensEnum["accessToken"] = "accessToken";
    OktaTokensEnum["idToken"] = "idToken";
})(OktaTokensEnum || (OktaTokensEnum = {}));
//# sourceMappingURL=okta-types.js.map